import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { CONTENT_MAP } from "@/data/siteContent";

const ContentCtx = createContext({ overrides: {}, reload: () => {} });
export const useContentStore = () => useContext(ContentCtx);

export function ContentProvider({ children }) {
  const [overrides, setOverrides] = useState({});
  const reload = useCallback(() => {
    api.get("/content").then(({ data }) => setOverrides(data || {})).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return <ContentCtx.Provider value={{ overrides, reload }}>{children}</ContentCtx.Provider>;
}

// comportamento responsivo per tipo: [min rem, vw scaling]
const KIND = {
  display: [2.4, 9],
  heading: [1.6, 6],
  sub: [1.15, 3.4],
  body: [1, 2.2],
  label: [0.7, 1.2],
};

// unisce default (registry) + override salvato
export function resolveContent(key, overrides) {
  const d = CONTENT_MAP[key] || {};
  const o = overrides?.[key] || {};
  return {
    text: o.text ?? d.text ?? "",
    size: o.size ?? d.size ?? null,
    weight: o.weight ?? d.weight ?? "normal",
    italic: o.italic ?? d.italic ?? false,
    align: o.align ?? d.align ?? "left",
    kind: d.kind || "body",
  };
}

export function EditableText({ k, as: Tag = "p", className = "" }) {
  const { overrides } = useContentStore();
  const c = resolveContent(k, overrides);
  const [minRem, vw] = KIND[c.kind] || KIND.body;
  const style = { textAlign: c.align };
  if (c.size) style.fontSize = `clamp(${minRem}rem, ${vw}vw, ${c.size}px)`;
  if (c.weight === "bold") style.fontWeight = 700;
  if (c.italic) style.fontStyle = "italic";
  const lines = String(c.text).split("\n");
  return (
    <Tag data-testid={`ct-${k}`} className={className} style={style}>
      {lines.map((l, i) => (
        <span key={i}>{i > 0 && <br />}{l}</span>
      ))}
    </Tag>
  );
}
